
export const classIf = (condition = false, className = "", elseClassName = "") => !!condition ? className : elseClassName